/**
 * RouteFallback — lightweight skeleton shown while a lazy-loaded route
 * chunk is still downloading. Deliberately minimal (single centred pulse
 * block) so perceived loading feels intentional, not laggy.
 *
 * Separate from AdminDashboardSkeleton (which mimics the full admin
 * dashboard structure) — this one is for generic public route transitions.
 */
export default function RouteFallback() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid="route-fallback">
      <div className="flex flex-col items-center gap-3 animate-pulse">
        <div className="w-10 h-10 rounded-full bg-[#E5E7EB]" />
        <div className="h-3 w-28 bg-[#F3F4F6] rounded" />
      </div>
    </div>
  );
}
